import { createBrowserRouter } from 'react-router-dom';
// LoginPage and RegistrationPage imports removed
import DashboardPage from '../pages/DashboardPage';
import Subscription from '../pages/Subscription';
import ChatPage from '../pages/ChatPage'; // Import ChatPage
import PaymentPage from "../pages/PaymentPage"; // Import new page
import PaymentMethodManagementPage from '../pages/PaymentMethodManagementPage';
import CompleteProfilePage from '../pages/CompleteProfilePage';
import UserProfilePage from '../pages/UserProfilePage'; // Added
import SmsPage from '../pages/SmsPage'; // SMS Page
import App from '../App';
import { AuthProvider } from '../contexts/AuthContext'; // Import useAuth
import CRMIntegrations from '../pages/CRMIntegrations';
import Channel from '../pages/Channels/Channel';
import AutomationPage from '../pages/Automation';
import { ProtectedMenuRoute } from '../components/ProtectedMenuRoute'; // Import ProtectedMenuRoute
import UsersList from '@/pages/UsersList';
import { ProtectedRoute } from '@/components/layout/ProtectedRoute';
import { ProtectedAdminRoute } from '@/components/layout/ProtectedAdminRoute';
import UserConfig from '@/pages/UserConfig';
import SubscriptionsManage from '@/pages/SubscriptionsManage';
import CreatePlan from '@/pages/CreatePlan';
import CreatePlanPeriod from '@/pages/CreatePlanPeriod';
import EditBillingPeriod from '@/pages/EditBillingPeriod';
import EditPlan from '@/pages/EditPlan';
import BitrixAllowedDomains from '@/pages/BitrixAllowedDomains';
import ChannelPlansStatus from '@/pages/ChannelPlansStatus';
import HowToConnectWithBX24 from '@/pages/HowToConnectWithBX24';
import AIChatbotDocumentation from '@/pages/AIChatbotDocumentation';
import AgentSettingsManage from '@/pages/AgentSettingsManage';
import ChatbotSettingsManage from '@/pages/ChatbotSettingsManage';

export const router = createBrowserRouter([
  {
    element: (
      <AuthProvider>
        <App />
      </AuthProvider>
    ), // App component renders Toaster and Outlet
    children: [
      {
        element: <ProtectedRoute />, // Wraps all protected routes
        children: [
          {
            path: '/',
            element: <DashboardPage />,
          },
          {
            path: '/channel/:channelId',
            element: <Channel />,
          },
          {
            path: '/chat',
            element: (
              <ProtectedMenuRoute href="/chat">
                <ChatPage />
              </ProtectedMenuRoute>
            ),
          },
          {
            path: '/subscription',
            element: (
              <ProtectedMenuRoute href="/subscription">
                <Subscription />
              </ProtectedMenuRoute>
            ),
          },
          {
            path: 'manage-payments',
            element: <PaymentMethodManagementPage />
          },
          {
            path: 'profile', // Added /profile route under ProtectedRoute
            element: <UserProfilePage />
          },
          {
            path: "/payment", // ADD THIS LINE
            element: <PaymentPage /> // ADD THIS LINE
          },
          {
            path: "/integrations", // ADD THIS LINE
            element: (
              <ProtectedMenuRoute href="/integrations">
                <CRMIntegrations />
              </ProtectedMenuRoute>
            ),
          },
          {
            path: "/sms",
            element: (
              <ProtectedMenuRoute href="/sms">
                <SmsPage />
              </ProtectedMenuRoute>
            ),
          },
          {
            path: "/automation/:channelId",
            element: <AutomationPage />
          },
          {
            path: "/how-to-connect-with-bx24",
            element: <HowToConnectWithBX24 />
          },
          {
            path: "/ai-chatbot-documentation",
            element: <AIChatbotDocumentation />
          }

          
          // Add other protected dashboard routes here
        ],
      },
      {
        element: <ProtectedAdminRoute />,
        children: [
          {
            path: '/users',
            element: <UsersList />,
          },
          {
            path: '/users/:userId/settings',
            element: <UserConfig />,
          },
          {
            path: '/subscriptions-manage',
            element: <SubscriptionsManage />,
          },
          {
            path: '/plans/create',
            element: <CreatePlan />,
          },
          {
            path: '/plans/:planId/edit',
            element: <EditPlan />,
          },
          {
            path: '/billing-periods/:periodId/edit',
            element: <EditBillingPeriod />,
          },
          {
            path: '/billing-periods/create',
            element: <CreatePlanPeriod />,
          },
          {
            path: '/bitrix-allowed-domains',
            element: <BitrixAllowedDomains />,
          },
          {
            path: '/channel-plans-status',
            element: <ChannelPlansStatus />,
          },
          {
            path: '/agent-settings',
            element: <AgentSettingsManage />,
          },
          {
            path: '/chatbot-settings',
            element: <ChatbotSettingsManage />,
          }
        ],
      },
      {
        path: '/complete-profile',
        element: <CompleteProfilePage />
      }
      // UnauthenticatedRoute and its children (login, register) are removed.
    ],
  },
]);
